import { render, staticRenderFns } from "./ModalThema.vue?vue&type=template&id=5a8f7cac&"
import script from "./ModalThema.vue?vue&type=script&lang=js&"
export * from "./ModalThema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports